import { z } from "zod";

/** Stellar public key: 56 chars, starts with G, base32 */
const stellarKeyRegex = /^G[A-Z2-7]{55}$/;

export const whitelistingSchema = z
	.object({
		walletType: z.enum(["custodial", "non-custodial"]),
		partnerName: z.string().min(1, "Wallet Name is required"),
		emailAddress: z
			.string()
			.min(1, "Email Address is required")
			.email("Invalid email address"),
		clientDomain: z.string().min(1, "Client Domain is required"),
		authenticationWalletAccounts: z.string().optional(),
		withdrawWalletAccounts: z.string().optional(),
		depositWalletAccounts: z.string().optional(),
		authAddress: z.string().optional(),
		withdrawAddress: z.string().optional(),
		depositAddress: z.string().optional(),
	})
	.superRefine((data, ctx) => {
		if (data.walletType === "custodial") {
			if (!data.authenticationWalletAccounts?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Authentication Wallet Account is required",
					path: ["authenticationWalletAccounts"],
				});
			} else if (
				!stellarKeyRegex.test(data.authenticationWalletAccounts.trim())
			) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message:
						"Must be a valid Stellar public key (G followed by 55 characters)",
					path: ["authenticationWalletAccounts"],
				});
			}
			if (!data.withdrawWalletAccounts?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Withdraw Wallet Account is required",
					path: ["withdrawWalletAccounts"],
				});
			} else if (!stellarKeyRegex.test(data.withdrawWalletAccounts.trim())) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message:
						"Must be a valid Stellar public key (G followed by 55 characters)",
					path: ["withdrawWalletAccounts"],
				});
			}
			if (!data.depositWalletAccounts?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Deposit Wallet Account is required",
					path: ["depositWalletAccounts"],
				});
			} else if (!stellarKeyRegex.test(data.depositWalletAccounts.trim())) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message:
						"Must be a valid Stellar public key (G followed by 55 characters)",
					path: ["depositWalletAccounts"],
				});
			}
		}
	});

export type WhitelistingFormData = z.infer<typeof whitelistingSchema>;
